import { Globals } from "../CoreApp/Globals";

export function doOptimize() {
  Globals._pageOptimizeSpacer = true;
  var w = Globals._wsMgr;
  if (w == null || w.fCanvasPanel == null) return;
  var doCheckPoint = w["doCheckPoint"];
  var doProgress = w["doProgress"];
  if (doCheckPoint) w.StartCheckPoint();
  w.fCanvasPanel.DoOptimizePage(
    w["aspectRatio"],
    w["allowSort"],
    w["treeSingles"],
    w["branchPrefs"],
    w["param"],
    w["optimizeAll"]
  );
  if (doCheckPoint) w.EndCheckPoint();
  if (doProgress) w.EndProgress();
  var activeSelection = w.fCanvasPanel.GetFirstSelectedBox(null);
  if (activeSelection) {
    var dbObj = activeSelection.GetDataObj();
    w.fCanvasPanel.FocusObject({ recordId: dbObj?.GetObjectRecordID() });
  }
  w.PrepRenderWS();
  w.RenderWS();
}
